import { BaseDto } from '../base.dto';

export class SurfboardBillingPlanDto extends BaseDto {
  surfboardBillingPlanId?: string;
  code?: string;
  name?: string;
}